import {
  FAST_CHECKOUT_CYCLES, FAST_CHECKOUT_PAYMENT_METHODS,
} from '@/pages/FastCheckout/FastCheckout.enum.jsx';
import React from 'react';

export default {
  backButton: 'Volver',
  cartTitle: 'Carrito',
  resumeTitle: 'Resumen de compra',
  product: 'Producto',
  renewal: 'Próxima renovación ',
  total: 'Total del pedido: ',
  value: 'Valor: ',
  discountTag: 'Descuento',
  ctaPurchase: 'Finalizar compra',
  securityReminder: 'Transacción segura y encriptada',
  confirmPaymentLoading: 'Estamos preparando todo para ti...',
  errorToast: 'Ocurrió un error inesperado, inténtalo más tarde ',
  purchaseErrorToast: {
    title: 'Su pago no se ha completado',
    description: 'Verifique los datos de la tarjeta, el saldo o intente con otra tarjeta de crédito.',
  },
  paymentTitle: 'Pago',
  renewalSamePaymentMethod: (
    <>
      <span>Renovación automática: </span>
      Este producto se renovará automáticamente en la tarjeta de crédito registrada. Puedes cancelar suscripciones en cualquier momento.
    </>
  ),
  renewalSamePaymentMethodInTrial: (
    <>
      <span>Importante: </span>
      Solo cobramos en la tarjeta después de los 7 días de prueba. Te avisaremos por correo electrónico antes de que termine el período de prueba.
    </>
  ),
  taxToolTip: {
    title: 'Impuestos y tarifas',
    description: 'La aplicación del impuesto VAT/IVA puede identificarse en dos tipos de compras:',
    topics: [
      {
        id: 1,
        text: 'Compras realziadas por personas físicas en el sitio de HostGator Argentina',
      },
      {
        id: 2,
        text: 'Las efectuadas en los sitios de HostGator por personas con residencia dentro del territorio europeo',
      },
    ],
  },
  personalDataForm: {
    fields: {
      foreigner: {
        label: 'Sou estrangeiro',
      },
      nacionality: {
        label: 'Nacionalidade',
      },
      document: {
        label: 'Documento',
      },
      birthDate: {
        label: 'Fecha de nacimiento',
      },
      name: {
        label: 'Nombre completo',
      },
      companyName: {
        label: 'Razón Social',
      },
      companyResponsible: {
        label: 'Representante legal',
      },
      company: {
        label: 'Soy Empresa',
      },
      telephone: {
        label: 'Celular',
      },
      country: {
        label: 'País de residencia',
      },
      cep: {
        label: 'Cep',
      },
      postalCode: {
        label: 'Codigo Postal',
      },
      state: {
        label: 'Estado',
      },
      city: {
        label: 'Ciudad',
      },
      address: {
        label: 'Direccíon',
      },
      block: {
        label: 'Colonia',
      },
      complement: {
        label: 'Número',
      },
    },
    dontKnowMyCep: {
      label: 'No sé mi código postal',
    },
  },
  cycles: {
    [FAST_CHECKOUT_CYCLES.MONTHLY]: 'Plan mensual',
    [FAST_CHECKOUT_CYCLES.QUARTERLY]: 'Plan trimestral',
    [FAST_CHECKOUT_CYCLES.SEMIANNUALLY]: 'Plan semestral',
    [FAST_CHECKOUT_CYCLES.ANNUALLY]: 'Plan anual',
  },
  paymentMethods: {
    [FAST_CHECKOUT_PAYMENT_METHODS.CREDIT_CARD]: {
      label: 'Complete los datos de la tarjeta de crédito',
      ccAlreadyRegistered: 'Tarjeta registrada',
      newCC: 'Nueva Tarjeta de Crédito',
      alreadyRegisteredTitle: 'Informaciones de la tarjeta registrada',
      nextPayment: 'Próximo pago',
      expire: 'Vencimiento: ',
      dateGrouper: 'de',
    },
  },
  successPage: {
    title: 'Pago completado',
    description: (
      <>
        ¡Felicidades! Su pago se ha realizado.
        <br />
        En breve recibirá un correo electrónico de confirmación.
      </>
    ),
    ctaLabel: 'Ok, entendí',
  },
};
